var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mock-page mock-container"},[_c('label',{staticClass:"mock-label"},[_vm._v(" "+_vm._s(_vm.$t('mockPagePlaceholder'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }